import { TFunction } from 'i18next';

import { ADDON_KIND, ADDON_PRODUCT_KIND, VOICE_ADDONS_KINDS } from '@mfe/shared/constants';
import { IndoorUnit } from '@mfe/shared/schema-types';

export const hasEquipmentAlert = (indoorUnit: IndoorUnit | null, t: TFunction<string[]>) =>
  indoorUnit?.deviceModel && !(indoorUnit?.deviceModel?.toUpperCase() === t('contactInfo.modem.sb2'));

export const shouldRenderAddonDisclosure = (kind: string) =>
  kind === ADDON_PRODUCT_KIND.staticIp ||
  kind === ADDON_KIND.STATIC_IP ||
  kind === ADDON_PRODUCT_KIND.voice ||
  VOICE_ADDONS_KINDS.includes(kind);
